import React, { useEffect, useRef, useState } from 'react'
import { Col, FormFeedback, Label, Modal, ModalBody, ModalHeader, Row, Form, Input, ModalFooter, Button, Spinner } from 'reactstrap';
import * as Yup from "yup";
import { useFormik } from "formik";
import moment from 'moment';
import { ToastContainer } from 'react-toastify';
import { ADMIN_UPDATE_ORGANIZATION, POST_CITIES, POST_GET_INDUSTRY_TYPE, POST_PINCODE, Get_cities, Get_Countries, SALES_PERSON_LIST } from '../../helpers/url_helper';
import { APIClient } from '../../helpers/api_helper';
import Toast from '../../Components/Common/Toast';
import { HandleErrorMessage } from '../../Components/Common/HandleErrorMessage';
import { useMasterApi } from '../../Components/Hooks/UserHooks';
const api = new APIClient();


const UpdateAdmin = ({ orgDetail, modal_grid, setmodal_grid, EmployeeDataApi }) => {
    const { masterApiData } = useMasterApi()
    const isEmailDisabled = true;
    const phoneNumberRules = /^[1-9]\d{9}$/;
    const { orgid, orgname, email, city, country, address, pincode, industryType, mobileNumber, state,salesPersonId } = orgDetail
    const [loading, setLoading] = useState(false);
    const [industryTypeData, setIndustryTypeData] = useState()
    const [getCity, setGetCity] = useState([])
    const [postalCode, setPostalCode] = useState([])
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedCity, setSelectedCity] = useState("");
    const [customCity, setCustomCity] = useState("");
    const [searchResults, setSearchResults] = useState(null);
    const [salesPersonList, setSalesPersonList] = useState([]);

    const { handleSubmit, errors, touched, getFieldProps, setFieldValue } = useFormik({
        enableReinitialize: true,
        initialValues: {
            organizationName: orgname || "",
            email: email || "",
            mobileNumber: mobileNumber || "",
            city: city || "",
            state: state || "",
            country: country || "",
            address: address || "",
            industryType: industryType || "",
            pincode: pincode || "",
            salesPersonId: salesPersonId || '',

        },
        validationSchema: Yup.object({
            organizationName: Yup.string().required("Please Enter Employee Name"),
            mobileNumber: Yup.string().matches(phoneNumberRules, { message: "Please Enter 10 Digit Mobile Number" }).required("Please Enter Your Mobile Number"),
        }),
        onSubmit: async (values) => {
            setLoading(true);


            try {
                let data = {
                    organizationId: orgid
                };
                if (values.email !== email) {
                    data.email = values.email;
                }
                if (values.organizationName !== orgname) {
                    data.organizationName = values.organizationName;
                }
                if (values.mobileNumber !== mobileNumber) {
                    data.mobileNumber = values.mobileNumber;
                }
                if (values.city !== city) {
                    data.city = values.city;
                }
                if (values.state !== state) {
                    data.state = values.state;
                }
                if (values.country !== country) {
                    data.country = values.country;
                }
                if (values.address !== address) {
                    data.address = values.address;
                }
                if (values.industryType !== industryType) {
                    data.industryType = values.industryType;
                }
                if (values.pincode !== pincode) {
                    data.pincode = values.pincode;
                }
                if(values.salesPersonId !== "") {
                    data.salesPersonId = values.salesPersonId;
                }

                const response = await api.patch(`${ADMIN_UPDATE_ORGANIZATION}`, data);
                if (response?.success === true) {
                    Toast(response?.message, "success");
                    setTimeout(() => {
                        setmodal_grid(false);
                        EmployeeDataApi()
                    }, 2000);
                }
            } catch (error) {
                HandleErrorMessage(error);
            } finally {
                setLoading(false);
            }
        },
    });

    const toggle = () => {
        // if (modal_grid) {
        //     formik.resetForm();
        // }
        setmodal_grid(!modal_grid);
    };

    useEffect(() => {
        fetchUserData()
    }, [])

    const fetchUserData = async () => {
        try {
            const res = await api.get(`${POST_GET_INDUSTRY_TYPE}`)
            if (res.success === true) {
                setIndustryTypeData(res?.data)
            }
        }
        catch (error) {
            console.log("error", error)
        }
    }

    // const getCities = async (state) => {
    //     try {
    //         const data = { statName: state };
    //         const response = await api.create(`${POST_CITIES}`, data)
    //         if (response.success === true) {
    //             setGetCity(response.data)
    //         }
    //     } catch (error) {
    //         console.log(error, "error");
    //     }
    // }


    // const getPostalCode = async (city) => {
    //     try {
    //         const data = { cityName: city }
    //         const response = await api.create(`${POST_PINCODE}`, data)
    //         if (response.success === true) {
    //             setPostalCode(response.data)
    //         }

    //     } catch (error) {
    //         console.log(error, "error");
    //     }
    // }

    const fetchCountries = async () => {
        try {
            const response = await api.create(`${Get_Countries}`);
            if (response?.success && response?.data && response?.data.data) {
                const filteredCountries = response?.data.data.filter(
                    (country) => country !== ""
                );
                setCountries(filteredCountries);
            }
        } catch (error) {
            Toast("Failed to fetch countries list", "error");
        }
    };

    const fetchSalesPersons = async () => {
        try {
            const response = await api.get(`${SALES_PERSON_LIST}`, {
                method: 'GET',
            });
    
            if (response?.success && response?.data?.responseData) {
                const salesPersons = response.data.responseData;
                setSalesPersonList(salesPersons); // store list in state
            } else {
                Toast("Failed to fetch sales persons list", "error");
            }
        } catch (error) {
            console.error("Sales person API error:", error);
            Toast("Something went wrong while fetching sales persons", "error");
        }
    };
    
    useEffect(() => {
        fetchCountries();
        fetchCitiesByCountry(country)
        fetchSalesPersons();
    }, [country]);

    //fetch cities based on country
    const fetchCitiesByCountry = async (country) => {
        try {
            const data = { _id: country };
            const response = await api.create(`${Get_cities}`, data);
            if (response.success === true) {
                setGetCity(response.data.data);
            }
        } catch (error) {
            console.log(error, "error");
        }
    };

    const handleCountryChange = (event) => {
        const country = event.target.value;
        setSelectedCountry(country);
        setFieldValue("country", country);

        // Reset the city field and the "Other" selection
        setSelectedCity(null);
        setCustomCity("");
        setFieldValue("city", "");
        setSearchResults([]);

        // Fetch cities for the selected country
        fetchCitiesByCountry(country);
    };

    const handleSearch = (searchTerm) => {
        if (!searchTerm.trim()) {
            setSearchResults(null);
            return;
        }

        const filteredCities = getCity.filter(city =>
            city.toLowerCase().includes(searchTerm.toLowerCase())
        );

        if (!filteredCities.includes("Other")) {
            filteredCities.push("Other");
        }

        setSearchResults(filteredCities);
    };

    return (
        <Row>
            <ToastContainer />
            <Modal
                isOpen={modal_grid}
                toggle={() => {
                    toggle();
                }}>
                <ModalHeader className="bg-light p-3" id="exampleModalLabel" toggle={toggle}>Update Employee</ModalHeader>
                <Form
                    onSubmit={handleSubmit}
                    className="needs-validation">
                    <ModalBody>
                        <div className="mb-3">
                            <Row>
                                <Col sm={6}>
                                    <Label htmlFor="organizationName" className="form-label">Name</Label>
                                    <Input
                                        data-tooltip-id="my-tooltip-1"
                                        name="organizationName"
                                        autoComplete="new-password"
                                        type="text"
                                        placeholder="Enter Organization Name"
                                        {...getFieldProps('organizationName', { autoComplete: 'off' })}
                                        className="form-control"
                                        invalid={touched.organizationName && errors.organizationName}
                                    />
                                    {touched.organizationName && errors.organizationName && (
                                        <FormFeedback type="invalid"></FormFeedback>
                                    )}
                                </Col>
                                <Col sm={6}>
                                    <Label htmlFor="useremail" className="form-label">Email Address</Label>
                                    <Input
                                        name="email"
                                        autoComplete="new-password"
                                        data-tooltip-id="my-tooltip-2"
                                        type="email"
                                        placeholder="Enter email address"
                                        {...getFieldProps('email', { autoComplete: 'off' })}
                                        className="form-control"
                                        invalid={touched.email && errors.email}
                                        disabled={isEmailDisabled}
                                    />
                                    {touched.email && errors.email && (
                                        <FormFeedback type="invalid"></FormFeedback>
                                    )}

                                </Col>
                            </Row>
                        </div>

                        <div className="mb-3">
                            <Row>
                                <Col sm={6}>
                                    <Label htmlFor="ContactNumber" className="form-label">Contact Number</Label>
                                    <Input
                                        name="mobileNumber"
                                        autoComplete="new-password"
                                        data-tooltip-id="my-tooltip-3"
                                        type="tel"
                                        placeholder="Enter Contact No."
                                        {...getFieldProps('mobileNumber')}
                                        className="form-control"
                                        invalid={touched.mobileNumber && errors.mobileNumber}
                                    />
                                    {(touched.mobileNumber && errors.mobileNumber) && (
                                        <FormFeedback type="invalid"></FormFeedback>
                                    )}
                                </Col>
                                <Col sm={6}>
                                    <Label htmlFor="address" className="form-label">Address</Label>
                                    <Input
                                        data-tooltip-id="my-tooltip-7"
                                        name="address"
                                        autoComplete="new-password"
                                        type="text"
                                        placeholder="Enter Address"
                                        {...getFieldProps('address')}
                                        className="form-control"
                                        invalid={touched.address && errors.address}
                                    />
                                    {(touched.address && errors.address) && <FormFeedback type="invalid"></FormFeedback>}

                                </Col>
                            </Row>
                        </div>

                        <div className="mb-3">
                            <div className="s_col_no_resize s_col_no_bgcolor">
                                <Row>
                                    <Col sm={6}>
                                        <Label htmlFor="country" className="form-label">Select Country</Label>
                                        {/* <select data-tooltip-id="my-tooltip-5"
                                            className={`form-select ${touched.countrycode && errors.countrycode ? 'is-invalid' : ''}`}
                                            name="countrycode" {...getFieldProps('countrycode')}
                                            value={getFieldProps('countrycode').value || `${industryTypeData?.countryList[0]?.code},${industryTypeData?.countryList[0]?.name}`}>
                                            <option value="" disabled>Select Country</option>
                                            <option value={`${industryTypeData?.countryList[0]?.code},${industryTypeData?.countryList[0]?.name}`}>{industryTypeData?.countryList[0]?.name}</option>
                                        </select>
                                        {(touched.countrycode && errors.countrycode) && <FormFeedback type="invalid"></FormFeedback>} */}
                                        <select
                                            data-tooltip-id="my-tooltip-5"
                                            className={`form-select ${touched.country && errors.country
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                            name="country"
                                            value={getFieldProps("country").value}
                                            onChange={handleCountryChange}
                                            onBlur={getFieldProps("country").onBlur}
                                        >
                                            <option value="" disabled>
                                                Select Country
                                            </option>
                                            {countries.map((country, index) => (
                                                <option key={index} value={country}>
                                                    {country}
                                                </option>
                                            ))}
                                        </select>
                                        {touched.country && errors.country && (
                                            <div className="invalid-feedback">
                                                {errors.country}
                                            </div>
                                        )}
                                    </Col>

                                    <Col sm={6}>
                                        <Label htmlFor="state" className="form-label">Select State</Label>
                                        <input
                                            data-tooltip-id="my-tooltip-6"
                                            type="text"
                                            className={`form-control ${touched.state && errors.state
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                            name="state"
                                            {...getFieldProps("state")}
                                            placeholder="Enter State"
                                        />
                                        {touched.state && errors.state && (
                                            <div className="invalid-feedback">
                                                {errors.state}
                                            </div>
                                        )}

                                    </Col>

                                </Row>
                            </div>
                        </div>

                        <div className="mb-3">
                            <Row>
                                <Col sm={6}>
                                    <Label htmlFor="City" className="form-label">
                                        {selectedCity === "Other" ? "Other City" : "City"}
                                    </Label>
                                    <div className="position-relative">
                                        <input
                                            type="text"
                                            data-tooltip-id="my-tooltip-8"
                                            className={`form-control ${touched.city && errors.city ? "is-invalid" : ""
                                                }`}
                                            name="city"
                                            value={
                                                selectedCity === "Other" ? customCity : getFieldProps("city").value
                                            }
                                            onChange={(e) => {
                                                if (selectedCity === "Other") {
                                                    setCustomCity(e.target.value);
                                                } else {
                                                    setFieldValue("city", e.target.value);
                                                    handleSearch(e.target.value);
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    if (searchResults && searchResults.length > 0) {
                                                        const firstCity = searchResults[0];
                                                        setSelectedCity(firstCity);
                                                        setFieldValue("city", firstCity);
                                                        if (firstCity === "Other") {
                                                            setCustomCity("");
                                                        } else {
                                                            // handleCityClick(firstCity);
                                                        }
                                                        setSearchResults(null);
                                                    }
                                                }
                                            }}
                                            onBlur={getFieldProps("city").onBlur}
                                            placeholder={
                                                selectedCity === "Other" || !selectedCity ? "Search city..." : "Enter Other City..."
                                            }
                                        />
                                        {searchResults && searchResults.length > 0 && (
                                            <div
                                                className="position-absolute w-100 bg-white border rounded mt-1"
                                                style={{ zIndex: 1000, maxHeight: "200px", overflowY: "auto" }}
                                            >
                                                {searchResults.map((city, index) => (
                                                    <div
                                                        key={index}
                                                        className="p-2 cursor-pointer hover:bg-light"
                                                        onClick={() => {
                                                            setSelectedCity(city);
                                                            setFieldValue("city", city);
                                                            if (city === "Other") {
                                                                setCustomCity("");
                                                            } else {
                                                                // handleCityClick(city);
                                                            }
                                                            setSearchResults(null);
                                                        }}
                                                    >
                                                        {city}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    {touched.city && errors.city && (
                                        <div className="invalid-feedback">{errors.city}</div>
                                    )}
                                </Col>

                                <Col sm={6}>
                                    <Label
                                        htmlFor="pincode"
                                        className="form-label"
                                    >
                                        Postal-Code
                                    </Label>
                                    <input
                                        data-tooltip-id="my-tooltip-4"
                                        type="tel"
                                        className={`form-control ${touched.pincode && errors.pincode
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                        name="pincode"
                                        onInput={(e) => {

                                            e.target.value = e.target.value.slice(0, 12);
                                        }}
                                        {...getFieldProps("pincode")}
                                        placeholder="Enter Postal Code"
                                    />
                                    {touched.pincode && errors.pincode && (
                                        <div className="invalid-feedback">
                                            {errors.pincode}
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </div>

                        <div className="mb-3">
                            <Row>
                                <Col sm={6}>
                                    <Label htmlFor="stateIndustry" className="form-label">Select Industry</Label>
                                    <select data-tooltip-id="my-tooltip-9" name="stateIndustry" id="industryType" {...getFieldProps('industryType')} className={`form-select ${touched.industryType && errors.industryType ? 'is-invalid' : ''}`} >
                                        <option value="" disabled>Select Industry</option>
                                        {(industryTypeData?.industryType || [])?.map((ele, index) => {
                                            return (
                                                <>
                                                    <option key={ele} value={ele}>{ele}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                    {(touched.industryType && errors.industryType) && <FormFeedback type="invalid"></FormFeedback>}

                                </Col>

                                <Col sm={6}>
                               <Label htmlFor="salesPersonId" className="form-label">Select Sales Person</Label>
                               <select
                                   data-tooltip-id="my-tooltip-10"
                                   name="salesPersonId"
                                   id="salesPersonId"
                                   {...getFieldProps('salesPersonId')}
                                   className={`form-select ${touched.salesPersonId && errors.salesPersonId ? 'is-invalid' : ''}`}
                               >
                                   <option value="" disabled>Select Sales Person</option>
                                   {salesPersonList.map((person) => (
                                       <option key={person._id} value={person._id}>
                                           {person.name} 
                                       </option>
                                   ))}
                               </select>
                               {(touched.salesPersonId && errors.salesPersonId) && <FormFeedback type="invalid"></FormFeedback>}
                              </Col>
                            </Row>
                        </div>

                    </ModalBody>
                    <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                            <Button d="add-btn" disabled={loading ? true : false} className="btn btn-danger w-100" type="submit">
                                {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : null}
                                Update
                            </Button>
                        </div>
                    </ModalFooter>
                </Form>
            </Modal>
        </Row>
    )
}

export default UpdateAdmin